import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AppError } from "@/jenesys-types/errors";
import { Client, Company, User } from "@/jenesys-types/jenesys-entities/config";

export interface PracticeWithClients {
  practice: Company;
  clients: Client[];
}

export interface OperatorState {
  user: User | null;
  practicesWithClients: PracticeWithClients[];
  isLoading: boolean;
  error?: AppError;
}

export type FetchOperatorDataAction = PayloadAction<void>;

interface FetchOperatorDataSuccessPayload {
  user: User;
  practicesWithClients: PracticeWithClients[];
}
export type FetchOperatorDataSuccessAction =
  PayloadAction<FetchOperatorDataSuccessPayload>;

interface FetchOperatorDataFailurePayload {
  error: AppError;
}
export type FetchOperatorDataFailureAction =
  PayloadAction<FetchOperatorDataFailurePayload>;

const name = "state/features/operator";

export const initialState: OperatorState = {
  user: null,
  practicesWithClients: [],
  isLoading: false,
  error: undefined
};

const operatorSlice = createSlice({
  name,
  initialState,
  reducers: {
    fetchOperatorData: (state) => {
      state.isLoading = true;
      state.error = undefined;
    },
    fetchOperatorDataSuccess: (
      state,
      action: FetchOperatorDataSuccessAction
    ) => {
      state.isLoading = false;
      state.user = action.payload.user;
      state.practicesWithClients = action.payload.practicesWithClients;
      state.error = undefined;
    },
    fetchOperatorDataFailure: (
      state,
      action: FetchOperatorDataFailureAction
    ) => {
      state.isLoading = false;
      state.error = action.payload.error;
    }
  }
});

export const {
  fetchOperatorData,
  fetchOperatorDataSuccess,
  fetchOperatorDataFailure
} = operatorSlice.actions;

export default operatorSlice.reducer;

// Selectors
const selectOperatorState = (state: any) => state.features.operator;

export const selectOperatorUser = createSelector(
  [selectOperatorState],
  (operatorState: OperatorState) => operatorState.user
);

export const selectOperatorPracticesWithClients = createSelector(
  [selectOperatorState],
  (operatorState: OperatorState) => operatorState.practicesWithClients
);

export const selectOperatorDataLoading = createSelector(
  [selectOperatorState],
  (operatorState: OperatorState) => operatorState.isLoading
);

export const selectOperatorDataError = createSelector(
  [selectOperatorState],
  (operatorState: OperatorState) => operatorState.error
);


